import styled from "styled-components";

const ZeTableHeader = styled.thead`
  background-color: #f7f7f7;
`;

export default ZeTableHeader;
